// extracted by mini-css-extract-plugin
export default {"container":"CardCta_container__njt0r","ant-btn":"CardCta_ant-btn__qXx23","textTitle":"CardCta_textTitle__oenfr","content":"CardCta_content__rAFvx"};